import { lazyNamed } from 'src/utils/lazyNamed.ts';
import CompanyDetails from './containers/CompanyDetails/index.ts';
import { CompanyDetailsTab } from './containers/CompanyDetails/types.ts';
import { CompanyFormSearchKey } from './containers/CompanyForm/types.ts';

export { CompanyFormSearchKey, CompanyDetailsTab };

export default {
  CompaniesList: lazyNamed(() => import('./containers/CompaniesList/index.tsx'), 'CompaniesList'),
  CompanyForm: lazyNamed(() => import('./containers/CompanyForm/index.tsx'), 'CompanyForm'),
  CompanyDetails,
};
